import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

export function ChangePasswordDialog({ open, onOpenChange, forced = false }) {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (f.new_password.length < 8) return toast.error("New password must be at least 8 characters");
    if (f.new_password !== f.confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setUser?.({ ...user, must_change_password: false });
      setF({ current_password: "", new_password: "", confirm: "" });
      onOpenChange(false);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!forced || o) onOpenChange(o); }}>
      <DialogContent data-testid="change-password-modal" onInteractOutside={(e) => forced && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-display">{forced ? "Choose your new password" : "Change Password"}</DialogTitle>
          <DialogDescription>{forced ? "You signed in with a temporary passcode. Please set a personal password to continue." : "Use at least 8 characters."}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <div className="space-y-1"><Label>{forced ? "Temporary passcode" : "Current password"}</Label><Input data-testid="pw-current" type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} /></div>
          <div className="space-y-1"><Label>New password</Label><Input data-testid="pw-new" type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} /></div>
          <div className="space-y-1"><Label>Confirm new password</Label><Input data-testid="pw-confirm" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} /></div>
        </div>
        <DialogFooter><Button data-testid="pw-save" onClick={save} disabled={busy || !f.current_password || !f.new_password}>{busy ? "Saving…" : "Update password"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
